import script from "./UsersReviewList.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersReviewList.vue?vue&type=script&setup=true&lang=js"

import "./UsersReviewList.vue?vue&type=style&index=0&id=76f52d92&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f52d92"]])

export default __exports__